<div class="form-container" id="syllabus_form" appearance="outlined" data-tfa="creer_objet-maquette">
    <mat-card-title>
        <h2>Descripteurs Syllabus</h2>
    </mat-card-title>
    <mat-card-content>
        <ng-container [formGroup]="form.asFormGroup">
            <mat-card class="subform-card" data-tfa="generalites_card">
                <h3 mat-card-subtitle>Généralités</h3>
                <mat-form-field class="form-field">
                    <mat-label>Objectifs</mat-label>
                    <textarea
                        cdkTextareaAutosize
                        data-tfa="input_objectif_descripteurs_syllabus"
                        matInput
                        formControlName="objectif"
                    ></textarea>
                    <mat-hint>{{ form.asFormGroup.controls.objectif.value?.length ?? 0 }} / 2000 </mat-hint>
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.objectif"></mat-error>
                </mat-form-field>
                <mat-form-field class="form-field">
                    <mat-label>Description</mat-label>
                    <textarea
                        cdkTextareaAutosize
                        data-tfa="input_description_descripteurs_syllabus"
                        matInput
                        formControlName="description"
                    ></textarea>
                    <mat-hint>{{ form.asFormGroup.controls.description.value?.length ?? 0 }} / 2000 </mat-hint>
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.description"></mat-error>
                </mat-form-field>
                <mat-form-field class="form-field">
                    <mat-label>Prérequis Pédagogiques</mat-label>
                    <textarea
                        data-tfa="input_prerequis_pedagogique_descripteurs_syllabus"
                        matInput
                        formControlName="prerequisPedagogique"
                        cdkTextareaAutosize
                    ></textarea>
                    <mat-hint>{{ form.asFormGroup.controls.prerequisPedagogique.value?.length ?? 0 }} / 2000 </mat-hint>
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.prerequisPedagogique"></mat-error>
                </mat-form-field>
                <mat-slide-toggle
                    class="center-toggle"
                    data-tfa="input_ouverture_mobilite_entrante_descripteurs_syllabus"
                    formControlName="ouvertureALaMobiliteEntrante"
                    (toggleChange)="toggleOuvertureALaMobiliteEntrante()"
                >
                    ouverture à la mobilite entrante
                </mat-slide-toggle>
            </mat-card>

            <mat-card class="subform-card" data-tfa="modalites_card">
                <h3 mat-card-subtitle>Modalités du cours et des évaluations</h3>
                <mat-form-field class="form-field">
                    <mat-label>Langue d'Enseignement</mat-label>
                    <textarea
                        data-tfa="input_langue_enseignement_descripteurs_syllabus"
                        matInput
                        formControlName="langueEnseignement"
                        cdkTextareaAutosize
                    ></textarea>
                    <mat-hint>{{ form.asFormGroup.controls.langueEnseignement.value?.length ?? 0 }} / 2000 </mat-hint>
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.langueEnseignement"></mat-error>
                </mat-form-field>
                <mat-form-field class="form-field">
                    <mat-label>Modalités d'Enseignement</mat-label>
                    <textarea
                        data-tfa="input_modalites_enseignements_descripteurs_syllabus"
                        matInput
                        formControlName="modalitesEnseignements"
                        cdkTextareaAutosize
                    ></textarea>
                    <mat-hint>{{ form.asFormGroup.controls.modalitesEnseignements.value?.length ?? 0 }} / 500 </mat-hint>
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.modalitesEnseignements"></mat-error>
                </mat-form-field>
                @if (isObjetFormation) {
                <ng-container [formGroup]="getDescripteursObjetFormationSyllabus()">
                    <mat-form-field class="form-field">
                        <mat-label>Volume horaire par type de cours</mat-label>
                        <textarea
                            data-tfa="input_colume_horaire_descripteurs_syllabus"
                            matInput
                            formControlName="volumeHoraireParTypeDeCours"
                            cdkTextareaAutosize
                        ></textarea>
                        <mat-hint
                            >{{ form.asFormGroup.get('descripteursObjetFormationSyllabus.volumeHoraireParTypeDeCours')!.value?.length ?? 0 }}
                            / 2000
                        </mat-hint>
                        <mat-error
                            *appFormMatErrors="form.asFormGroup.get('descripteursObjetFormationSyllabus.volumeHoraireParTypeDeCours')!"
                        ></mat-error>
                    </mat-form-field>
                    <mat-form-field class="form-field">
                        <mat-label>Coefficient</mat-label>
                        <input data-tfa="input_coefficient_descripteurs_syllabus" matInput formControlName="coefficient" />
                        <mat-hint
                            >{{ form.asFormGroup.get('descripteursObjetFormationSyllabus.coefficient')!.value?.length ?? 0 }} / 200
                        </mat-hint>
                        <mat-error *appFormMatErrors="form.asFormGroup.get('descripteursObjetFormationSyllabus.coefficient')!"></mat-error>
                    </mat-form-field>
                    <mat-form-field class="form-field">
                        <mat-label>Modalités d'évaluation</mat-label>
                        <textarea
                            data-tfa="input_modalites_evaluation_descripteurs_syllabus"
                            matInput
                            formControlName="modalitesEvaluation"
                            cdkTextareaAutosize
                        ></textarea>
                        <mat-hint
                            >{{ form.asFormGroup.get('descripteursObjetFormationSyllabus.modalitesEvaluation')!.value?.length ?? 0 }} / 2000
                        </mat-hint>
                        <mat-error
                            *appFormMatErrors="form.asFormGroup.get('descripteursObjetFormationSyllabus.modalitesEvaluation')!"
                        ></mat-error>
                    </mat-form-field>
                </ng-container>
                }
            </mat-card>

            <mat-card class="subform-card" data-tfa="biblio_card">
                <h3 mat-card-subtitle>Bibliographie</h3>
                <mat-form-field class="form-field">
                    <mat-label>Bibliographie</mat-label>
                    <textarea
                        data-tfa="input_bibliographie_descripteurs_syllabus"
                        matInput
                        formControlName="bibliographie"
                        cdkTextareaAutosize
                    ></textarea>
                    <mat-hint>{{ form.asFormGroup.controls.bibliographie.value?.length ?? 0 }} / 2000 </mat-hint>
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.bibliographie"></mat-error>
                </mat-form-field>
            </mat-card>
            <mat-card class="subform-card" data-tfa="contats_card">
                <h3 mat-card-subtitle>Contacts</h3>
                <mat-form-field class="form-field">
                    <mat-label>Contacts</mat-label>
                    <textarea
                        data-tfa="input_contacts_descripteurs_syllabus"
                        matInput
                        formControlName="contacts"
                        cdkTextareaAutosize
                    ></textarea>
                    <mat-hint>{{ form.asFormGroup.controls.contacts.value?.length ?? 0 }} / 2000 </mat-hint>
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.contacts"></mat-error>
                </mat-form-field>
            </mat-card>

            <mat-card class="subform-card" data-tfa="autres_card">
                <h3 mat-card-subtitle>Autres</h3>
                <mat-form-field class="form-field">
                    <mat-label>Autres Informations</mat-label>
                    <textarea
                        data-tfa="input_autres_informations_descripteurs_syllabus"
                        matInput
                        formControlName="autresInformations"
                        cdkTextareaAutosize
                    ></textarea>
                    <mat-hint>{{ form.asFormGroup.controls.autresInformations.value?.length ?? 0 }} / 2000 </mat-hint>
                    <mat-error *appFormMatErrors="form.asFormGroup.controls.autresInformations"></mat-error>
                </mat-form-field>
            </mat-card>

            <div class="buttons-horizontal-container">
                <ng-content select="#bouton-fermer-objet-maquette"></ng-content>
                <button
                    data-tfa="objet-maquette-créer-button"
                    mat-raised-button
                    color="primary"
                    [disabled]="form.isPristine || !form.isValid"
                    (click)="modifierDescripteursSyllabus()"
                >
                    <mat-icon data-tfa="icone-valider">check</mat-icon>
                    Enregistrer
                </button>
            </div>
        </ng-container>
    </mat-card-content>
</div>
